<template>
  <VEmojiPicker @select="addEmoji"
                v-if="$store.getters['webchat/isEmojiPickerShown'] "
                :labelSearch="$t('form.pick_your_emoji')" />
</template>

<script>
import { VEmojiPicker } from 'v-emoji-picker'

export default {
  name: 'Emoji',
  components: {
    VEmojiPicker
  },
  props: {
    addEmoji: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
#EmojiPicker {
  position: absolute !important;
  bottom: 40px;
  left: -270px;

  span.border {
    border: none !important;
  }
}

.container-search {
  margin: 10px 0px;
  padding: 0;
  position: relative;
  top: 12px;
  width: calc(100% - 25px);

  input {
    padding: 6px 8px;
  }
}
</style>
